import { useState } from 'react';

import { WidgetViewMode, WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { SummaryCard } from 'api/queries/getProjectStatusScoreCards.query';

import { ProgressCard } from 'components/widgets/ProjectSummary/components/CardsSection/components/ProgressCard/ProgressCard';
import { QualityCard } from 'components/widgets/ProjectSummary/components/CardsSection/components/QualityCard/QualityCard';
import { RiskCard } from 'components/widgets/ProjectSummary/components/CardsSection/components/RiskCard/RiskCard';

interface Props {
    progressCardData: SummaryCard | undefined;
    riskCardData: SummaryCard | undefined;
    qualityCardData: SummaryCard | undefined;
    widgetViewMode?: WidgetViewMode;
}
const CHART_HEIGHT_IN_REPORT_VIEW = '100%';
const CHART_HEIGHT_IN_PAGE_VIEW = 300;

export const CardsSection = ({ progressCardData, riskCardData, qualityCardData, widgetViewMode }: Props) => {
    const [collapse, setCollapse] = useState<boolean>(true);

    const chartHeight = WidgetViewModeUtils.isReportView(widgetViewMode)
        ? CHART_HEIGHT_IN_REPORT_VIEW
        : CHART_HEIGHT_IN_PAGE_VIEW;
    const canExpand = !WidgetViewModeUtils.isInAnyReportMode(widgetViewMode); // We don't want to show the details on report
    return (
        <>
            {progressCardData?.cardProperties && (
                <ProgressCard
                    {...progressCardData}
                    collapse={collapse}
                    setCollapse={setCollapse}
                    chartHeight={chartHeight}
                    canExpand={canExpand}
                />
            )}
            {riskCardData?.cardProperties && (
                <RiskCard
                    {...riskCardData}
                    collapse={collapse}
                    setCollapse={setCollapse}
                    chartHeight={chartHeight}
                    canExpand={canExpand}
                />
            )}
            {qualityCardData?.cardProperties && (
                <QualityCard
                    {...qualityCardData}
                    collapse={collapse}
                    setCollapse={setCollapse}
                    chartHeight={chartHeight}
                    canExpand={canExpand}
                />
            )}
        </>
    );
};
